class MenuMobile {

    button = false
    target = false
    closeButton = false
    overlay = false
    handleOut = null

    constructor() {

        this.button = document.querySelector('.menu-toggle')
        this.target = document.querySelector('.menu-mobile')
        this.overlay = document.querySelector('.menu-mobile > .overlay')
        this.modalyFire = document.querySelector('.modal-quentinhas');
        this.mainMenu = document.querySelector('.menu-mobile > .overlay > .menu')
        this.searchMenu = document.querySelector('.menu-mobile > .overlay > .search')
        this.buttonSearch = document.querySelector('button.search')
        this.inner = document.querySelector('.inner')
        this.buttonContact = document.getElementById('contact-footer')
        this.contactMenu = document.querySelector('.contato')

        if (this.target && this.button) {

            this.handleOut = this.clickOut.bind(this)

            this.button.addEventListener('click', (event) => {
                event.preventDefault()
                this.togglePanel(this.mainMenu)
            })

            if (this.buttonSearch) {
                this.buttonSearch.addEventListener('click', (event) => {
                    event.preventDefault()
                    this.togglePanel(this.searchMenu)
                })
            }

            if (this.buttonContact) {
                this.buttonContact.addEventListener('click', (event) => {
                    event.preventDefault()
                    this.togglePanel(this.contactMenu)
                })
            }

            // Close button
            this.closeButton = this.target.querySelector('button.close')
            if (this.closeButton) {
                this.closeButton.addEventListener('click', (event) => {
                    event.preventDefault()
                    this.close()
                })
            }

        }

    }

    clickOut(event) {

        if (
            !this.overlay.contains(event.target)
            &&
            !this.inner.contains(event.target)
            &&
            !Piki.hasParent(event.target, 'menu-toggle')
            &&
            !event.target.classList.contains('menu-toggle')
            &&
            !(this.buttonContact && this.buttonContact.contains(event.target))
        ) {
            this.close()
        }

    }

    toggle() {
        this.togglePanel(this.mainMenu)
    }

    togglePanel(panel) {

        if (this.target.classList.contains('opened') && panel.classList.contains('visible')) {
            this.close()
        } else {
            this.open(panel)
        }

    }

    open(panel = this.mainMenu) {

        this.target.classList.add('opened')
        this.button.classList.add('active')
        window.addEventListener('click', this.handleOut)
        this.modalyFire.classList.add('hidden')

        this.showPanel(panel)

        if (window.innerHeight === this.target.offsetHeight) {
            Piki.lockScroll()
        }

    }

    showPanel(panel) {

        this.mainMenu.classList.toggle('visible', panel === this.mainMenu)
        this.searchMenu.classList.toggle('visible', panel === this.searchMenu)
        this.contactMenu.classList.toggle('visible', panel === this.contactMenu)

    }

    close() {

        this.target.classList.remove('opened')
        this.button.classList.remove('active')
        this.modalyFire.classList.remove('hidden')
        window.removeEventListener('click', this.handleOut)
        Piki.unlockScroll()

    }

}

window.addEventListener('DOMContentLoaded', () => {
    new MenuMobile()
});